<template>
  <div class="operation-lst">
    <van-tabs v-model="active">
      <van-tab :title="$t('option.tab1')">
        <InProgressOrder ref="InProgressOrder" />
      </van-tab>
      <van-tab :title="$t('option.tab2')">
        <SettlementOrder ref="SettlementOrder" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import InProgressOrder from "./inprogress.vue";
import SettlementOrder from "./settlement.vue";
export default {
  name: "UsrOperationOrder",
  components: { InProgressOrder, SettlementOrder },
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    active(newval) {
      console.log(newval);
      const that = this;

      this.$nextTick(() => {
        if (newval == 1) {
          if (that.$refs.SettlementOrder) {
            that.$refs.SettlementOrder.onRefresh();
          }
        }
        if (newval == 0) {
          if (that.$refs.InProgressOrder) {
            that.$refs.InProgressOrder.onRefresh();
          }
        }
      });
    },
  },
  methods: {
    loadData() {},
  },
};
</script>

<style>
</style>
